// Kanban column definitions and lead-to-column mapping logic
// Maps existing stage + interest_status fields to 8 Kanban columns
// No database changes required

export const KANBAN_COLUMNS = [
  {
    id: 'discovery',
    title: 'Discovery',
    color: '#6366f1', // indigo
  },
  {
    id: 'interested',
    title: 'Interested',
    color: '#8b5cf6', // violet
  },
  {
    id: 'in_conversation',
    title: 'In Conversation',
    color: '#3b82f6', // blue
  },
  {
    id: 'call_booked',
    title: 'Call Booked',
    color: '#06b6d4', // cyan
  },
  {
    id: 'plan_participant_client',
    title: 'Plan Participant Client',
    color: '#10b981', // emerald
  },
  {
    id: 'crownmark_client',
    title: 'CrownMark Client',
    color: '#f59e0b', // amber
  },
  {
    id: 'legacy_suite_client',
    title: 'Legacy Suite Client',
    color: '#f97316', // orange
  },
  {
    id: 'inactive',
    title: 'Inactive',
    color: '#6b7280', // gray
  },
];

// Determine which Kanban column a lead belongs to
// Priority order prevents overlaps
export function getKanbanColumnId(lead) {
  const stage = lead.stage;
  const interest = lead.interest_status;

  // Priority 1: CrownMark Client (interest_status === 'closed')
  if (interest === 'closed') return 'crownmark_client';

  // Priority 2: Legacy Suite Client
  if (interest === 'legacy_suite') return 'legacy_suite_client';

  // Priority 3: Inactive (unqualified stage)
  if (stage === 'unqualified') return 'inactive';

  // Priority 4: Plan Participant Client (qualified stage)
  if (stage === 'qualified') return 'plan_participant_client';

  // Priority 5: In Conversation (assigned stage)
  if (stage === 'assigned') return 'in_conversation';

  // Priority 6: Call Booked (engaged + meeting_booked)
  if (stage === 'engaged' && interest === 'meeting_booked') return 'call_booked';

  // Priority 7: Interested (engaged + interested)
  if (stage === 'engaged' && interest === 'interested') return 'interested';

  // Priority 8: Discovery (cold stage or fallback)
  if (stage === 'cold') return 'discovery';

  // Default: Discovery for any unmapped leads
  return 'discovery';
}

// Group an array of leads into Kanban columns
export function groupLeadsByColumn(leads) {
  const grouped = {};
  KANBAN_COLUMNS.forEach(col => {
    grouped[col.id] = [];
  });

  leads.forEach(lead => {
    const columnId = getKanbanColumnId(lead);
    if (grouped[columnId]) {
      grouped[columnId].push(lead);
    } else {
      grouped['discovery'].push(lead);
    }
  });

  return grouped;
}

// Get the DB update payload when a card is dropped into a new column
export function getDropUpdatePayload(destinationColumnId) {
  switch (destinationColumnId) {
    case 'discovery':
      return { stage: 'cold' };
    case 'interested':
      return { stage: 'engaged', interest_status: 'interested' };
    case 'in_conversation':
      return { stage: 'assigned' };
    case 'call_booked':
      return { stage: 'engaged', interest_status: 'meeting_booked' };
    case 'plan_participant_client':
      return { stage: 'qualified' };
    case 'crownmark_client':
      return { interest_status: 'closed' };
    case 'legacy_suite_client':
      return { interest_status: 'legacy_suite' };
    case 'inactive':
      return { stage: 'unqualified' };
    default:
      return { stage: 'cold' };
  }
}
